import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/Button';
import type { ContractInfo } from '@/api/smart-contracts';

type ContractResponseProps = {
  response: ContractInfo | null;
  error: string | null;
  onClear: () => void;
};

export function ContractResponse({
  response,
  error,
  onClear,
}: ContractResponseProps) {
  if (!response && !error) return null;

  return (
    <>
      {error && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="rounded-lg bg-red-900/30 border border-red-700/50 px-4 py-3 text-red-200 flex items-center justify-between gap-3"
        >
          <span className="flex-1 min-w-0">{error}</span>
          <Button
            variant="outline"
            size="sm"
            onClick={onClear}
            className="shrink-0"
          >
            Clear
          </Button>
        </motion.div>
      )}

      {response && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="rounded-lg bg-gray-800 border border-gray-700 overflow-hidden"
        >
          <div className="px-4 py-3 border-b border-gray-700 bg-gray-800/80 flex items-center justify-between">
            <h2 className="text-lg font-semibold text-white">
              Contract info
            </h2>
            <Button variant="outline" size="sm" onClick={onClear}>
              Clear
            </Button>
          </div>
          <pre className="p-4 text-sm text-gray-300 overflow-x-auto max-h-[70vh] overflow-y-auto">
            {JSON.stringify(response, null, 2)}
          </pre>
        </motion.div>
      )}
    </>
  );
}
